export type LosType = 'encompass' | 'ml-consumer' | 'ml-mortgage';

export type UserRole = 'lender-admin' | 'lender-standard' | 'lender-read-only';

export const LOS_LABELS: Record<LosType, string> = {
  encompass: 'Encompass',
  'ml-consumer': 'MeridianLink Consumer',
  'ml-mortgage': 'MeridianLink Mortgage',
};

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  'lender-admin': 'Lender Admin',
  'lender-standard': 'Lender Standard',
  'lender-read-only': 'Lender Read-Only',
};

export interface AccountData {
  lenderName: string;
  /** The account's identifying code — it becomes the lender urn (`urn:lender:<lenderId>`).
   * Generated by the wizard (10 lowercase alphanumerics, derived from the Lender Name), never
   * typed or shown (OM-3918).
   * Suggested from the Lender Name, operator-editable; nothing derives it server-side (the
   * naming rule moved to the wizard on 2/9). */
  lenderId: string;
  salesforceId: string;
  nmlsId: string;
  street: string;
  city: string;
  state: string;
  zip: string;
  entityId: string;
  entityName: string;
  apiUsername: string;
  apiPassword: string;
}

export interface LosIntegration {
  type: LosType;
  credentials: Record<string, string>;
}

export interface WizardUser {
  id: string;
  firstName: string;
  lastName: string;
  /**
   * Only collected while MeridianLink Consumer is one of the selected LOS integrations. The value
   * survives deselecting it — confirmed by the client — so this is not cleared when the field
   * stops being shown.
   */
  mlConsumerUserName: string;
  /**
   * Only collected while MeridianLink Mortgage is one of the selected LOS integrations — the
   * per-user login Mortgage requests identify the user by. Preserved when hidden, like the
   * Consumer one.
   */
  mlMortgageUserName: string;
  email: string;
  role: UserRole | '';
  /** null = inherits every product enabled in Step 3 — the restrict toggle's default. */
  productAccess: Record<string, boolean> | null;
}

export interface WizardState {
  step: number;
  /**
   * Set when a step is opened from a Step 5 "Edit" link: Next then returns to the summary instead
   * of walking the steps in between, until the summary is reached again.
   */
  returnToReview: boolean;
  account: AccountData;
  losIntegrations: LosIntegration[];
  products: Record<string, boolean>;
  users: WizardUser[];
}

export const TOTAL_STEPS = 5;
